module.exports = __webpack_public_path__ + "a42bb00526166c2ad40441382b3e8cbe.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/raymond.png
// module id = 804
// module chunks = 0